/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'training': {
    width: 27,
    height: 20,
    viewBox: '0 0 27 20',
    data: '<path pid="0" d="M26.197 6.967L13.593.105c-.21-.14-.42-.07-.63 0L6.87 3.466c-.07 0-.14 0-.21.07L.359 7.037c-.21.14-.35.35-.35.56v10.364c0 .35.28.63.63.63s.63-.28.63-.63V8.718l2.661 1.47v3.291s.49 6.512 9.313 6.512c4.551 0 6.862-1.61 7.982-2.94 1.19-1.541 1.33-3.082 1.33-3.152V9.98l3.572-1.961c.14-.14.28-.35.42-.49 0-.21-.14-.42-.35-.56zm-4.972 6.862c0 .07-.35 4.902-8.052 4.902-7.633 0-8.053-5.112-8.053-5.322v-2.59l7.843 4.2c.07.07.21.07.28.07.07 0 .21 0 .28-.07l7.702-4.34v3.15zm-7.982-.07L1.899 7.597l11.344-6.302 11.273 6.162-11.273 6.302z" _fill="#848484" fill-rule="nonzero"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/training.js